import { Container, Typography } from "@mui/material";
import FadeIn from "../../../../../../../layouts/fade-in";
import ImageGallery from "../../../../../components/ImageGallery";

export default function OneProduct__TextAndTagging(props) {
  return (
    <FadeIn>
      <Container>
        <Typography
          className={props.fontStyle}
          variant="subtitle1"
          sx={{
            color: "#ffffff44",
            lineHeight: 1.3,
            textAlign: "center",
            marginTop: 2,
            marginBottom: 4,
          }}
        >
          The <span style={{ color: "#ffbf12" }}>buyer</span> gets a{" "}
          <span style={{ color: "#ffbf12" }}>shoutout</span> with{" "}
          <span style={{ color: "#ffbf12" }}>just</span> their{" "}
          <span style={{ color: "#ffbf12" }}>handle</span>.<br />
          It’s a{" "}
          <span style={{ color: "#ffbf12" }}>
            fixed templatE — text & tagging only
          </span>{" "}
          with no option to add text or images, <br />
          and the{" "}
          <span style={{ color: "#ffbf12" }}>delivery is fully automated.</span>
          <br />
          <br />{" "}
          <span style={{ color: "#ffbf12" }}>
            Below, you can see examples of Shoutouts on the Shoutout Wall.
          </span>
        </Typography>
        <img
          src="/images/shoutout-wall-step3.png"
          alt="Shoutouts on the Shoutout Wall"
          style={{ width: '720px', display: 'block', margin: '0 auto' ,paddingLeft: '75px'}}
        />
        {/* <ImageGallery
          images={[
            "/images/ty-mention-ex1.png",
            "/images/ty-mention-ex2.png",
            "/images/ty-mention-ex3.png",
          ]}
          thumbnail
        /> */}
      </Container>
    </FadeIn>
  );
}
